// $(document).ready(function(){

	//shop hover
	// $(".nav-left li.shop-li, .shop-mega").hover(function() {
	// 	$(".nav-left li.shop-li").children("a").addClass("hover-a");
	// 	$(".megamenu").addClass("border-mega");
	// 	$(".shop-mega").stop().fadeIn("fast");
	// }, function () {
	// 	$(".nav-left li.shop-li").children("a").removeClass("hover-a");
	// 	$(".megamenu").removeClass("border-mega");
    //     $(".shop-mega").fadeOut('fast');
  	// });

	  $(".nav-left li.shop-li, .shop-mega,.nav_wrapper").hover(function() {

		$(".nav_wrapper").addClass("content_height");
		}, function () {

		$(".nav_wrapper").removeClass("content_height");
	  });

  	//help hover
  	$(".nav-right li.help-li, .help-mega").hover(function() {
		$(".nav-right li.help-li").children("a").addClass("hover-a");
		$(".megamenu").addClass("border-mega");
		$(".help-mega").stop().fadeIn("fast");
	}, function () {
		$(".nav-right li.help-li").children("a").removeClass("hover-a");
		$(".megamenu").removeClass("border-mega");
        $(".help-mega").fadeOut('fast');
  	});

  	//banner click
  	$("#banner").on("click", function(){
  		var url = $(this).attr("banner-url");
  		window.location.href = url;
  	});

	  $("[data-featured-grid]").on("click", function(){
		var url = $(this).attr("data-featured-grid");
		if(url != '' && url != undefined && url != null) {
			window.location.href = url;
		}	
	});

	$("[data-image-with-text]").on("click", function(){
		var url = $(this).attr("data-image-with-text");
		if(url != '' && url != undefined && url != null) {
			window.location.href = url;
		}		
	});


  	//featured prod
  	$(".box .img, .big-box .img").on("click", function(){
  		var url = $(this).attr("box-url");
  		window.location.href = url;
  	});




	$(".box-slide").slick({
		infinite: true,
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: true,
    	centerMode: false,
	});

	$(document).ready(function(){
		$(".arrival_slider").slick({
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			cssEase: 'linear',
			variableWidth: false,
			centerMode: false,
			touchThreshold:100,
			prevArrow: '<button id="btn_prev"><svg class="arrival_prevArrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20 5.00004C20.265 5.00364 20.5192 5.10618 20.7125 5.28754C20.9003 5.47713 21.0056 5.73319 21.0056 6.00004C21.0056 6.26689 20.9003 6.52294 20.7125 6.71254L11.4125 16L20.7125 25.2875C20.872 25.4818 20.9534 25.7285 20.9411 25.9795C20.9288 26.2306 20.8235 26.4681 20.6458 26.6458C20.468 26.8236 20.2306 26.9288 19.9795 26.9412C19.7284 26.9535 19.4818 26.872 19.2875 26.7125L9.28749 16.7125C9.09971 16.5229 8.99436 16.2669 8.99436 16C8.99436 15.7332 9.09971 15.4771 9.28749 15.2875L19.2875 5.28754C19.4808 5.10618 19.7349 5.00364 20 5.00004Z" fill="black"/></svg></button>',
			nextArrow: '<button id="btn_next"><svg class="arrival_nextArrow" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12 27C11.735 26.9964 11.4808 26.8938 11.2875 26.7125C11.0997 26.5229 10.9944 26.2668 10.9944 26C10.9944 25.7331 11.0997 25.4771 11.2875 25.2875L20.5875 16L11.2875 6.71246C11.128 6.51817 11.0466 6.2715 11.0589 6.02045C11.0712 5.7694 11.1765 5.53191 11.3542 5.35417C11.532 5.17644 11.7694 5.07117 12.0205 5.05884C12.2716 5.04651 12.5182 5.128 12.7125 5.28746L22.7125 15.2875C22.9003 15.4771 23.0056 15.7331 23.0056 16C23.0056 16.2668 22.9003 16.5229 22.7125 16.7125L12.7125 26.7125C12.5192 26.8938 12.2651 26.9964 12 27Z" fill="black"/></svg></button>',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: false,
						dots: false,
						variableWidth: false
					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: false,
						dots: false,
						variableWidth: false
					}
				}
			]
		});
		
		var prdCount = $(".product-slide-ul").data('products-length') < 5 ? $(".product-slide-ul").data('products-length') : 5;
		$(".product-slide-ul").slick({
			infinite: false,
			  slidesToShow: prdCount,
			  slidesToScroll: 1,
			  arrows: true,
			  dots: false,
			  cssEase: 'linear',
			variableWidth: false,
			centerMode: false,
			touchThreshold:100,
			prevArrow: '<button class="slider_prev_btn"><svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.140583 3.6466C-0.0471093 3.84186 -0.0471093 4.15844 0.140583 4.3537L3.2002 7.53568C3.38799 7.73094 3.69241 7.73094 3.8801 7.53568C4.06789 7.34042 4.06789 7.02384 3.8801 6.82858L1.16049 4.00015L3.8801 1.17172C4.06789 0.976456 4.06789 0.659876 3.8801 0.464616C3.69241 0.269346 3.38799 0.269346 3.2002 0.464616L0.140583 3.6466ZM24.519 3.50015L0.480582 3.50015L0.480582 4.50015L24.519 4.50015L24.519 3.50015Z" fill="black"></path></svg></button>',
			nextArrow: '<button class="slider_next_btn"><svg width="25" height="8" viewBox="0 0 25 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.3785 4.35365C24.5662 4.15839 24.5662 3.84181 24.3785 3.64655L21.3188 0.464562C21.1311 0.2693 20.8266 0.2693 20.6389 0.464562C20.4512 0.659824 20.4512 0.976407 20.6389 1.17167L23.3586 4.0001L20.6389 6.82853C20.4512 7.02379 20.4512 7.34037 20.6389 7.53563C20.8266 7.7309 21.1311 7.7309 21.3188 7.53563L24.3785 4.35365ZM0 4.5001H24.0385V3.5001H0V4.5001Z" fill="black"></path></svg></button>',
			responsive: [
				{
					breakpoint: 769,
					settings: "unslick"
				}
			]
		});
	})

	$(".slide-ul-landing").slick({
		infinite: false,
	  	slidesToShow: 4,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: false,
    	centerMode: false,
		touchThreshold:100,
    	prevArrow: $("button.btn-fcs-prev"),
    	nextArrow: $("button.btn-fcs-next"),
    	responsive: [
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 2,
			        slidesToScroll: 2,
			        infinite: false,
			        dots: false,
			        variableWidth: true
			    }
    		}
    	]
	});

	$(".slide-ul").slick({
		infinite: false,
	  	slidesToShow: 5,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: false,
    	centerMode: false,
		touchThreshold:100,
    	prevArrow: $("button.btn-fcs-prev"),
    	nextArrow: $("button.btn-fcs-next"),
    	responsive: [
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 2,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: true,
			        variableWidth: true
			    }
    		}
    	]
	});
	$(".cat-shop-ul").slick({
		infinite: false,
	  	slidesToShow: 3,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: true,
    	centerMode: false,
    	prevArrow: $("button.btn-cat-prev"),
    	nextArrow: $("button.btn-cat-next"),
    	responsive: [
    		{
    			breakpoint: 1200,
			    settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: false,
			        variableWidth: false,
			        centerMode: false
			    }
    		},
    		{
    			breakpoint: 992,
			    settings: {
			        slidesToShow: 3,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: false,
			        variableWidth: false,
			        centerMode: false
			    }
    		},
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: true,
			        variableWidth: true,
			        centerMode: false
			    }
    		}
    	]
	});
	$(".image-parent").slick({
		infinite: false,
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: true,
	  	cssEase: 'linear',
    	variableWidth: false,
    	centerMode: false,
    	prevArrow: $("button.btn-it-prev"),
    	nextArrow: $("button.btn-it-next")
	});
	$(".insta-slider").slick({
		infinite: false,
	  	slidesToShow: 2,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	dots: false,
	  	cssEase: 'linear',
    	variableWidth: true,
    	centerMode: false,
    	prevArrow: $("button.btn-insta-prev"),
    	nextArrow: $("button.btn-insta-next"),
    	responsive: [
    		{
    			breakpoint: 768,
			    settings: {
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        infinite: false,
			        dots: false,
			        variableWidth: true,
			        centerMode: false
			    }
    		}
    	]
	});

	//ship-slider
	$('.ship-slider').slick({
		slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: false,
	  	fade: false,
		infinite: false,
		speed: 1000,
		nav: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 6000,
    	speed: 600
	});

	//New Navigation review-slider
	$('.review_slider_wrapper').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		infinite: false,
		speed: 1000,
		nav: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 600
	});

	//announcement-bar-slider	
	$('#announcement').slick({	
		slidesToShow: 1,	
		slidesToScroll: 1,	
		arrows: false,	
		fade: false,	
		infinite: true,	
		speed: 1000,	
		nav: true,	
		dots: false,	
		autoplay: true,	
		autoplaySpeed: 6000,	
		speed: 600,	
		vertical: true,	
		verticalSwiping: true,	
	});

	//product
	$('.product-slider').slick({
	  	slidesToShow: 1,
	  	slidesToScroll: 1,
	  	arrows: true,
	  	fade: true,
		infinite: false,
		speed: 1000,
		adaptiveHeight: false,
	  	asNavFor: '.thumbnail-slider',
	    arrows: false,
	    swipe: false,
	    responsive: [
	    	{
	    		breakpoint: 768,
	    		settings: {
	    			dots: true,
	    			swipe: true,
	    			focusOnSelect: false,
	    			touchThreshold:300,
	    			fade: false,
	    			infinite: true
	    		}
	    	}
	    ]
	});
	$('.thumbnail-slider').slick({
	  	slidesToShow: 8,
	  	slidesToScroll: 8,
	  	asNavFor: '.product-slider',
	  	dots: false,
	  	focusOnSelect: true
	});

	if(document.querySelector(".hero-slider") != null) {
		let isDots = false;
		let isArrows = false;
		let isAutoPlay = false;
		if(document.querySelector('[data-slider-autoplay]').dataset.sliderAutoplay == 'true') {
			isAutoPlay = true;
		}
		var autoPlaySpeed = document.querySelector('[data-autoplay-speed]').dataset.autoplaySpeed.toString() + '000';
		if(document.querySelector('[data-total-blocks]').dataset.totalBlocks > 1) {
			isDots = true;
			isArrows = true;
		}
	   
		$(".hero-slider").slick({
			infinite: true,
			  slidesToShow: 1,
			  slidesToScroll: 1,
			  arrows: isArrows,
			  dots: isDots,
			  cssEase: 'linear',
			variableWidth: false,
			centerMode: false,  
			prevArrow: $(".btn-banner-prev"),
			nextArrow: $(".btn-banner-next"),
			autoplay: isAutoPlay,
			   autoplaySpeed: autoPlaySpeed,
			fade: true
		});
		if(window.innerWidth < 990) {
			$('.hero-slider').on('touchcancel touchmove', e => {
				$(".hero-slider").slick('slickPlay');
			  });
			document.querySelectorAll("[prev-next-btn]").forEach((btn) => {
				btn.addEventListener("click", () => {
					$(".hero-slider").slick('slickPause');
				});
			});
		}
	}

	$(document).ready(function(){
		if(window.location.href.includes('/product') && document.querySelector('.mobile_afterpay_message afterpay-placement') != null){
			var afterpay = setInterval(function(){
			  if(document.querySelector('.mobile_afterpay_message afterpay-placement').shadow != null && 
			  document.querySelector('.mobile_afterpay_message afterpay-placement').shadow.querySelector(".afterpay-paragraph .afterpay-main-text") && 
			  document.querySelector('.mobile_afterpay_message afterpay-placement').shadow.querySelector(".afterpay-paragraph .afterpay-logo-link button") && 
			  document.querySelector('.mobile_afterpay_message afterpay-placement').shadow.querySelector(".afterpay-paragraph .afterpay-logo-link button svg")
			  ){
				document.querySelector('.mobile_afterpay_message afterpay-placement').shadow.querySelector(".afterpay-paragraph .afterpay-main-text").style.fontSize = "11px";	
				document.querySelector('.mobile_afterpay_message afterpay-placement').shadow.querySelector(".afterpay-paragraph .afterpay-logo-link button").style.width = "auto";
				document.querySelector('.mobile_afterpay_message afterpay-placement').shadow.querySelector(".afterpay-paragraph .afterpay-logo-link button svg").style.width = "60px";	
				clearInterval(afterpay);
			  }
			},10)
			setTimeout(()=>{
			  clearInterval(afterpay);
			},7000)
		  }
	})

	// pdp accordion 
	$(document).ready(function(){
		$(document).on('click','.feature_Accordion .description .description_upper_content',function(){
			$(this).siblings(".desc").toggleClass("show");
			$(this).children(".accordion_icon").children(".plus_icon").toggleClass("hide");
			$(this).children(".accordion_icon").children(".minus_icon").toggleClass("show");

		})

		$(document).on('click','.nav_wrapper .inner_nav .new_nav_men_megamenu .new_nav_men_submenu_section .new_nav_men_submenu .title_and_icon_wrapper',function(){
			$(this).siblings(".nav_submenu_list").toggleClass("show");

			$(this).children(".accordion_icon").children(".plus_icon").toggleClass("hide");
			$(this).children(".accordion_icon").children(".minus_icon").toggleClass("show");

		})

		$('.nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .men_toggle').addClass('selected_menu');

		$(document).on('click','.nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .men_toggle, .nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .women_toggle',function(){
			$('.nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .men_toggle, .nav_wrapper .inner_nav .men_women_toggle_wrapper .men_women_toggle .women_toggle').removeClass("selected_menu");
			$(this).addClass("selected_menu");
			if($(this).text().trim()=="Men"){
				$('#women_menu').removeClass('show');
				$('#men_menu').removeClass('hide');

				$('.men_review').removeClass('hide');
				$('.women_review').removeClass('show');

			}
			else{
				$('#men_menu').addClass('hide');
				$('#women_menu').removeClass('hide');
				$('#women_menu').addClass('show');

				$('.women_review').addClass('show');
				$('.men_review').addClass('hide');
			}

		})
	})

	//product size chart
    $(document).ready(function(){
		if($('[data-size-toggle]').length){
		  var notactiveSizeTog = $('[data-size-toggle]:not(.c-modalSizeChart1__button--isActive)').data('size-toggle');
		  if($('[data-size-toggle]:not(.c-modalSizeChart1__button--isActive)').length == 1){
			$('[data-size="'+notactiveSizeTog+'"]').hide();
		  } else{
			notactiveSizeTog = $($('[data-size-toggle]:not(.c-modalSizeChart1__button--isActive)')[$('[data-size-toggle]:not(.c-modalSizeChart1__button--isActive)').length - 1]).data('size-toggle');
			$('[data-size="'+notactiveSizeTog+'"]').hide();
		  }
		  
		}
		
	  })
	  $(document).on('click','#size', function(e) {
			e.preventDefault();
			$("#sizechart").toggleClass("is-visible");
			$("body").toggleClass("body-size");
	  });
  
	  $(document).on('click',"#sizechart .size-close", function(){
		  $("#sizechart").toggleClass("is-visible");
			$("body").toggleClass("body-size");
	  });
  
	  $(document).on('click','[data-size-toggle]',function(e){
		var size  = $(this).data('size-toggle');
		$('[data-size-toggle]').removeClass('c-modalSizeChart1__button--isActive');
		$(this).addClass('c-modalSizeChart1__button--isActive');
		$('[data-size]').hide();
		$('[data-size="'+size+'"]').show();
	  })

	$('#help-mobile-menu ul li').on('click', function(e){
		e.stopPropagation();
		//e.preventDefault();
		var liValue = $(this).text();
		$(this).parent().siblings('#help-text').text(liValue);
		$('.dropdown-option').slideUp();
		$('#help-text').removeClass('active');
		$('.dropdown-icon').removeClass('rotate');
	});


	//sizechart
	//tabs
	$('.measure-tabs span').click(function() {
	    // Check for active
	    $('.measure-tabs li').removeClass('measure-active');
	    $(this).parent().addClass('measure-active');

	    // Display active tab
	    let currentTab = $(this).attr('data-tab');
	    $('.measure-tab-contents .wrapper').hide();
	    $("#"+currentTab).show();
	    return false;
	});

	$(".sub-heads").on("swipe", function(event, slick, direction){
  		if (slick["currentSlide"] == 0) {
  			$(".sub-images .buzzfeed-img img").click();
  		}else if(slick["currentSlide"] == 1){
  			$(".sub-images .us-week-img img").click();
  		}
	});

	//mobile dropdown
	$('#help-text').on('click', function(e){
		e.stopPropagation();
		if($(this).siblings('ul').is(':visible')){
			$(this).siblings('ul').slideUp();
			$(this).siblings(".dropdown-icon").removeClass('rotate');
		}
		else{
			$(this).siblings('ul').slideDown();
			$(this).siblings('#help-text').addClass('active');
			$(this).siblings(".dropdown-icon").addClass('rotate');
		}
		
	});

	$('#help-mobile-menu ul li span').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();
		var liValue = $(this).text();
		$(this).parent().siblings('#help-text').text(liValue);
		$('.dropdown-option').slideUp();
		$('#help-text').removeClass('active');
		$('.dropdown-icon').removeClass('rotate');
	});

	$('#help-content .c-button').on('click', function() {
		console.log('yes click');
		if($('#links-accordions .link-none-block').length) {
			$('#links-accordions .link-none-block').each((i, ele) => {
				$(ele).removeClass('d-none');
			});

			if ($('#links-accordions .link-heading').length) {
			  $('#links-accordions .link-heading').each((i, ele) => {
				  $(ele).removeClass('d-none');
			  });
			}

			if($('.help-boxes .c-button').length) {
				$('.help-boxes .c-button').addClass('d-none');
			}		
		}		
	});

	$('.link-title').on('click', function(){
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$(this).children('svg').find('path:nth-child(2)').show();
			$(this).siblings('.link-content').slideUp();
		}
		else{
			$('.link-title').removeClass('active');
			$('.link-title').children('svg').find('path:nth-child(2)').show();
			$('.link-content').slideUp();

			$(this).addClass('active');
			$(this).children('svg').find('path:nth-child(2)').hide();
			$(this).siblings('.link-content').slideDown();
		}
	});


	//hamburger
	$(".hamburger-ul").click(function(){
	    $(".burger-open").toggleClass("opac-0");
	    $(".burger-close").toggleClass("opac-1");
	    // $("#hamburger-menu").toggleClass("nav-list-active");
		$(".nav_wrapper").toggleClass("content_height2");
		
	    $("body").toggleClass("body-over");

		let widgetUI = setInterval(() => {
            if(document.querySelectorAll('access-widget-ui').length > 0) {
                document.querySelectorAll('access-widget-ui').forEach((ele) => {
                if(ele.shadowRoot.querySelector("button[part='acsb-trigger']") != null) {
                    if(document.querySelector("#hamburger-menu").classList.contains("nav-list-active")) {
                      ele.shadowRoot.querySelector("button[part='acsb-trigger']").classList.add("hide");
                    } else {
                      ele.shadowRoot.querySelector("button[part='acsb-trigger']").classList.remove("hide");
                    }				
                }        
                });
                clearInterval(widgetUI);
            } else {
				setTimeout(() => {
					clearInterval(widgetUI);
				}, 10000);
			} 
        }, 10);	
        let gorgiasChat = setInterval(() => {
            if(document.querySelector("#gorgias-chat-container") != null) {
                if(document.querySelector("#hamburger-menu").classList.contains("nav-list-active")) {
                    document.querySelector("#gorgias-chat-container").classList.add("hidden");
                } else {
                    document.querySelector("#gorgias-chat-container").classList.remove("hidden");
                } 
                clearInterval(gorgiasChat);
            } else {
				setTimeout(() => {
					clearInterval(gorgiasChat);
				}, 10000);
			}
        }, 10);	
	});

	//ajax cart
	$(".cart-btn-head").click(function(e){
		e.preventDefault();
		$("body").addClass("cart-over");
		$("#cart-drawer").addClass("is-open");
		$("#cart-overlay").addClass("is-visible");
	});
	$("#cart-overlay, .cart-drawer-close").click(function(){
		$("body").removeClass("cart-over");
		$("#cart-drawer").removeClass("is-open");
		$("#cart-overlay").removeClass("is-visible");
	});

	//bundle add to cart	
	window.bundleAddtocart = function(data){	
		//console.log('Data==========>', window.bundledata.length);	
		//$(".summary-build-button button").text("Loading...");	
		Shopify.moveAlong = function() {	
			// If we still have requests in the queue, let's process the next one.	
		    //console.log('Start Function===========++');	
			if (window.bundledata.length){  //from bundle-builder.js	
			    var request = window.bundledata.shift(); //adds 1 by 1	
			    var data = 'id='+ request.id + '&quantity='+request.quantity	
			    $.ajax({	
			      	type: 'POST',	
		            url: '/cart/add.js',	
				    dataType: 'json',	
				    data: data,	
				    success: function(res){	
				        Shopify.moveAlong();	
				    },	
	             	error: function(error){	
			            console.log('error=========>', error);	
				     	// if it's not last one Move Along else update the cart number with the current quantity	
					 	if(window.bundledata.length){	
					    	Shopify.moveAlong()	
					  	}else{	
					    	//console.log("Added Successfully");	
					  	}	
			      	}	
		        });	
		    }else{// If the queue is empty, we add 1 to cart	
	
			  	fetchproducts();	
			}	
       };	
    	Shopify.moveAlong();	
	}


	//addtocart
	function addtocart(id, qty, prodID){
		var prodObject;
		if(prodID){
			prodObject = {
				items: [
					{
					  quantity: 1,
					  id: prodID
					},
					{
					  quantity: qty,
					  id: id
					}

				]
			}
		}
		$.ajax({
			type: 'POST',
	        url: '/cart/add.js',
	        data: prodObject ? prodObject : {
	            quantity: qty,
	            id: id
	        },
	        dataType: 'json',
	        success: function (data) {
	        	console.log('product added');
	        },
	        complete: function(){
	      		fetchproducts();
	      	},
	        error: function(error){
	        	console.log('error');
	        }
		})
		
	}

	function fetchproducts(){
		$.ajax({
		type: 'GET',
		url: '/cart.json',
		dataType: 'jsonp',
        cache: false,
        contentType: "application/json",                  
		 	success: function (data) { 
		 		var cart_list = [];
		 		var total = 0;
		 		var original_total_price = 0;
		 		var itemCount = 0;
		 		fetcheddata = data;
		 		total = (fetcheddata.total_price/100).toFixed(2);
		 		original_total_price = (fetcheddata.original_total_price/100).toFixed(2);
		 		itemCount = fetcheddata.item_count;
		 		fetcheddata.items.forEach(item => {
		    		var size = "";
					if (item.variant_title == "XSmall") {
			       size = "XSmall";
		      }else if (item.variant_title == "Small"){
					    size = "Small";
					}else if (item.variant_title == "Medium"){
					    size = "Medium";
					}else if (item.variant_title == "Large"){
					    size = "Large";
					}else if (item.variant_title == "Xlarge" || item.variant_title == "XLarge"){
					    size = "XLarge";
					}else if (item.variant_title == "2XLarge"){
					    size = "2XLarge";
					}else if (item.variant_title == "3XLarge" || item.variant_title == "3Xlarge"){
					    size = "3XLarge";
					}else if (item.variant_title == "4XLarge" || item.variant_title == "4Xlarge"){
					    size = "4XLarge";
					}else if (item.variant_title == "5XLarge" || item.variant_title == "5Xlarge"){
					    size = "5XLarge";
					}else{
						size = item.variant_title;
					}					

					const matches = window.productColors.filter(element => {
					  	if(item.product_title.includes(element)){
					    	return true;
					  	}
					});

					var color = "";
					var producttitle = "";

					if((item.product_type != "3pack") && (item.product_type != "One-Time 5-Pack")){
						if(matches.length > 0) {
						  	color = matches;
					      	if(matches.includes("Vintage White")){
					      		color="Vintage White";
					      		producttitle = item.product_title.replace(color, '');
					      	}else{
						  		color = matches;
					      		producttitle = item.product_title.replace(color, '');
					      	}
						}else{
							producttitle = item.product_title;
						}
					}else{
						producttitle = item.product_title;
					}

					var disc = item.discounts;
					var disc_title = "";
					for (var x = disc.length - 1; x >= 0; x--) {
                      let discTitle = "Bundle Discount";
                      let newDisc = discTitle + " - $3.00";
						disc_title = '<p class="ajax-discount">('+newDisc+')</p>';
					}
					var cart_Discountprice = "";
					if (item.discounted_price < item.original_price){
						cart_Discountprice = `<p class="ajax-final-price"><del>$`+((item.quantity)*(item.original_price/100)).toFixed(2)+`</del></p>`;
					}

					let priceItem = `<p class="ajax-price">$`+((item.quantity)*(item.discounted_price/100)).toFixed(2)+`</p>`;
                    if (item.product_type == "Free Gift") {
						priceItem = `<p class="ajax-price" style="color:#cb4b4b;text-transform: uppercase;">Free</p>`;
                    }/*else{
                    	priceItem = '$'+((item.quantity)*(item.final_price/100)).toFixed(2);
                    }*/


					
		    		cart_list.push('<div class="cart-item-box">'+
		    		'<ul class="flex_box ajax-cart-item"><li class="cart-image">'+
		    		'<a class="ajax-image">'+
		    			'<img src='+item.image+' | img_url: 320x" alt='+item.product_title+' | escape" />'+
		    		'</a>'+
		    		'</li>'+
		    		'<li class="cart-descr">'+
		    		'<a class="ajax-title">'+producttitle+'</a>'+
		    		'<p class="ajax-color">'+color+'</p>'+
		    		'<p class="ajax-size" style="text-transform: capitalize;">'+size+'</p>'+
		    		'<div class="qty-box">'+
		    		'<div class="cart-quantity">'+
		    		'<div class="control minus-control" variant-id="'+item.id+'">'+
		    		'<span class="qty-minus" data-update-quantity="minus">-</span>'+
		    		'</div>'+
		    		'<div class="control qty-control">'+
		    		'<input class="qty-input" type="number" min="1" name="updates[]" id="updates_'+item.key+' size="2" value='+item.quantity+' data-id='+item.key+' /></div>'+
		    		'<div class="control plus-control" variant-id="'+item.id+'" ><span class="qty-plus" data-update-quantity="plus">+</span></div></div></div></li>'+
		    		'<li class="cart-price">'+
		    		cart_Discountprice+	
		    		priceItem+	
		    		disc_title+	
		    		'</li></ul>'+
		    		'<div class="cart-delete" data-id="'+item.id+'"><a href="/cart/change?line=&amp;quantity=0">'+
		    		'<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">'+
		    		'<path d="M15.8312 19.8343H5.16786C4.94339 19.829 4.72216 19.7795 4.51682 19.6887C4.31147 19.5978 4.12604 19.4674 3.97111 19.3049C3.81617 19.1424 3.69478 18.951 3.61387 18.7415C3.53295 18.5321 3.4941 18.3087 3.49952 18.0843V6.55176H4.66619V18.0843C4.66062 18.1555 4.6692 18.2272 4.69143 18.2952C4.71366 18.3631 4.7491 18.426 4.79573 18.4802C4.84235 18.5344 4.89922 18.5789 4.96309 18.6111C5.02695 18.6432 5.09654 18.6624 5.16786 18.6676H15.8312C15.9025 18.6624 15.9721 18.6432 16.036 18.6111C16.0998 18.5789 16.1567 18.5344 16.2033 18.4802C16.2499 18.426 16.2854 18.3631 16.3076 18.2952C16.3298 18.2272 16.3384 18.1555 16.3329 18.0843V6.55176H17.4995V18.0843C17.5049 18.3087 17.4661 18.5321 17.3852 18.7415C17.3043 18.951 17.1829 19.1424 17.0279 19.3049C16.873 19.4674 16.6876 19.5978 16.4822 19.6887C16.2769 19.7795 16.0557 19.829 15.8312 19.8343Z" fill="#908F8F"/><path d="M17.9547 5.24967H2.91634C2.76163 5.24967 2.61326 5.18822 2.50386 5.07882C2.39447 4.96942 2.33301 4.82105 2.33301 4.66634C2.33301 4.51163 2.39447 4.36326 2.50386 4.25386C2.61326 4.14447 2.76163 4.08301 2.91634 4.08301H17.9547C18.1094 4.08301 18.2578 4.14447 18.3672 4.25386C18.4765 4.36326 18.538 4.51163 18.538 4.66634C18.538 4.82105 18.4765 4.96942 18.3672 5.07882C18.2578 5.18822 18.1094 5.24967 17.9547 5.24967Z" fill="#908F8F"/><path d="M12.249 7.58301H13.4157V16.333H12.249V7.58301Z" fill="#908F8F"/><path d="M7.58301 7.58301H8.74967V16.333H7.58301V7.58301Z" fill="#908F8F"/><path d="M13.4163 3.41866H12.308V2.33366H8.69134V3.41866H7.58301V2.33366C7.58263 2.03409 7.69751 1.74585 7.90384 1.52866C8.11017 1.31147 8.39214 1.18197 8.69134 1.16699H12.308C12.6072 1.18197 12.8892 1.31147 13.0955 1.52866C13.3018 1.74585 13.4167 2.03409 13.4163 2.33366V3.41866Z" fill="#908F8F"/></svg></a></div></div>');
		    		
		    	});
		    	$('.ajax-cart').html(cart_list.join(''));
		    	if(itemCount > 1){
		    		$('.item_counter').text(itemCount + ' items');
		    	}else{
		    		$('.item_counter').text(itemCount + ' item');
		    	}
		    	if(itemCount > 0){
		    		$('.empty-cart-content').css('display','none');
		    		$('#cart-form').css('display','block');
		    	}else{
		    		$('.empty-cart-content').css('display','block');
		    		$('#cart-form').css('display','none');
		    	}


		    	//only free shipping bar
		   		var onlyFreeAmt=parseInt($("#free-ship-only-amt").val());
		   		var onlyfreeShipping = parseInt((original_total_price/onlyFreeAmt)*100).toFixed(0);

		    	if(total<onlyFreeAmt){
		    		//console.log("fetchproducts else");
		    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
		    		$('.only-free-ship.free-disc-amount').text(0);
                    let discountRemAmt = (onlyFreeAmt-total).toFixed(2)
		    		$('.only-free-ship.discount-ship > p').html(`You're only <span class="free-disc-amount" id="disc-amount">$${discountRemAmt}</span> away from <span>Free Shipping</span>`);

		    		setTimeout(function () {
		    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
		    			$(".only-free-ship .disc-th-point").addClass("active-point").show();
		    		}, 200);
		    		$('.only-free-ship .disc-progress-filled').removeClass('ship-fill-green');
		    		$(".only-free-ship .disc-tag svg path").css("fill", "#cb4b4b");

		    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
		    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
		    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
		    	}else{
		    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
		    		$('.only-free-ship.free-disc-amount').text(0);

		    		$('.only-free-ship.discount-ship > p').html("YOU'VE UNLOCKED <span>FREE SHIPPING</span>");
		    		setTimeout(function () {
		    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
		    			$(".only-free-ship .disc-th-point").addClass("active-point").hide();
		    		}, 200);
		    		$('.only-free-ship .disc-progress-filled').addClass('ship-fill-green');
		    		$(".only-free-ship .disc-tag svg path").css("fill", "#39a33e");

		    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
		    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
		    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
		    	}
		    	$('.only-free-ship .disc-progress-empty .disc-progress-filled').css('width',onlyfreeShipping+'%');
		    	$('.only-free-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+onlyfreeShipping);




		    	var free_amt = parseInt($("#cart-drawer #free-amt").val());
				var free_discount_amt = parseInt($("#cart-drawer #free-disc-amt").val());
				var discountCode = $("#cart-drawer #disc-code").val();
				var freeShipping = (original_total_price/free_amt)*100;

		    	if(total < free_amt){
		    		$('.free-shipping-amount').text(free_amt - total);
		    		$('.shipping-bar > p').html('You\'re <span class="free-shipping-amount" id="ship-amount">$'+(free_amt - total)+'.00</span> away from <span id="ship-amount">'+free_discount_amt+'% OFF</span> ');
					$('.progress-filled').addClass('ship-fill');
					$('.progress-filled').removeClass('ship-fill-green');
					$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").removeClass('active-green-point');
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#BD5450");
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#BD5450");
		    	}else{
		    		$('.free-shipping-amount').text(0);
					$('.shipping-bar > p').html("You've Unlocked <span>"+free_discount_amt+"% OFF</span><br/>Use Code: <span class='discount-code'>"+discountCode+"</span>");
					$('.progress-filled').addClass('ship-fill-green');
					$('.progress-filled').removeClass('ship-fill');						
					$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").addClass('active-green-point');
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#38ae3a");
					$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#38ae3a");
		    	}
		    	
		    	$('.progress-empty .progress-filled').css('width',freeShipping+'%');


		    	//discount shipping bar
		    	var threshold_amt_2 = parseInt($("#cart-drawer #threshold-amt-2").val());
		    	var discount_amt = parseInt($("#cart-drawer #discount-amt").val());
		    	var discountShip = (total/threshold_amt_2)*100;

		    	var th1 = $("#cart-drawer #threshold-amt-1").val();
		   		var th2 = $("#cart-drawer #threshold-amt-2").val();


		   		if(original_total_price < threshold_amt_2){
		    		$('.free-disc-amount').text(threshold_amt_2 - original_total_price);
		    		$(".discount-ship .progress-bar").removeClass("ship-marg");
	    			$(".discount-ship .progress-bar").addClass("ship-marg-not");
		    		$(".discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
		    		$(".disc-progress-filled").addClass("active-point");
		    		$('.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "visible");
		    		$(".disc-th-point").removeClass("active-point");
		    		$(".disc-progress-filled").removeClass("full-disc");
		    		$('.discount-ship > p').html('You\'re only <span class="free-disc-amount" id="disc-amount">$'+(threshold_amt_2 - original_total_price)+'</span> away from <span>'+discount_amt+'% Off</span>');

		    	}else{
		    		$('.only-discount-ship.free-disc-amount').text(0);

		    		$('.only-discount-ship.discount-ship > p').html('You got <span>'+discount_amt+'% Off</span> at checkout!');
		    		setTimeout(function () {
		    			$(".only-discount-ship .disc-progress-filled").addClass("full-disc");
		    			$(".only-discount-ship .disc-th-point").addClass("active-point");
		    		}, 200);

		    		$('.only-discount-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
		    		$(".only-discount-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    			$(".only-discount-ship.discount-ship .progress-bar").addClass("ship-marg");
		    		$(".only-discount-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
		    	}
		    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled').css('width',discountShip+'%');
		    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+discountShip);
		    	
		    	$('.cart-btn-head .count').text(itemCount);
		    	if(total < original_total_price){	
		    		$('#ajax-original-total').text('$'+original_total_price);	
		    		$('#ajax-original-total').show();	
		    	}else{	
		    		$('#ajax-original-total').text('$'+original_total_price);	
		    		$('#ajax-original-total').hide();	
		    	}	
		    	$('#ajax-total').text('$'+total);
		    	opendrawer();
		 	},
		 	error: "failed"
		});
	}

	function opendrawer(){
		$("body").addClass("cart-over");
		$("#cart-drawer").addClass("is-open");
		$("#cart-overlay").addClass("is-visible");
	}

	// get specific VariantID from all variant	
	function get_variantID(size,length){	
		let variantdetail = window.globalVariantDetails;	
		let filteredDetail = variantdetail.filter(c=>c.option_text==`${size} / ${length}`);	
		if(filteredDetail.length>0){	
			return filteredDetail[0].option_value;	
		}	
	}

	$(document).on('click', '.btn-ajaxcart' ,function(e){ 
		e.preventDefault();

		var var_id = $(".productSelect").val();
		var qty = $("#qty").val();
		var selectedLength = $(".selected_length").text();	
		var selectedSize = $(".neck-size-name").text() || $(".size-swatch-name").text();	
		if(selectedLength=="Regular" || selectedLength=="Tall"){	
			var_id = get_variantID(selectedSize,selectedLength);	
		}
		var membershipID = $('#product').attr('membership-pack-id');
		var freegiftID = $('#product').attr('free-gift-id');
		if(membershipID){
			addtocart(var_id, qty,membershipID);
		}
		else{
			if(freegiftID){
				addtocart(var_id, qty,freegiftID);
			}
			else{
				addtocart(var_id, qty);
			}
		}
	}); 

	$(document).on('click','.cart-delete', function(e){
		e.preventDefault();
		var vid = $(this).attr('data-id');
		deleteProduct(vid);
	});


$(document).on('click','.minus-control', function(){
	var vid = $(this).attr('variant-id');
	var qty = parseInt($(this).siblings('.qty-control').children('input').val()) - 1;
	productQuantityUpdate(vid,qty);
});

$(document).on('click','.plus-control', function(){
	var vid = $(this).attr('variant-id');
	var qty = parseInt($(this).siblings('.qty-control').children('input').val()) + 1;
	productQuantityUpdate(vid,qty);
})



// Quantity increment and decrement
function productQuantityUpdate(id,quantity){
	$.ajax({
		type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: quantity,
            id: id
        },
        success: function (data){
			console.log('success');
        },
      	complete: function(){
      		fetchproducts();
      	},
        error: function(error){
        	console.log(error)
        }
	});
}


// Initial cart data fetch

function cartDataCheckOnLoad(){
	$.ajax({
		type: 'GET',
		url: '/cart.json',
		dataType: 'jsonp',
        cache: false,
        contentType: "application/json",                  
	 	success: function (data) {
	 		cartData = data;
	 		var total = (cartData.total_price/100).toFixed(2);
	 		var original_total_price = (cartData.original_total_price/100).toFixed(2);
	 		var itemCount = cartData.item_count;
	 		if(itemCount > 0){
	    		$('.empty-cart-content').css('display','none');
	    		$('#cart-form').css('display','block');
	    	}else{
	    		$('.empty-cart-content').css('display','block');
	    		$('#cart-form').css('display','none');
	    	}


	    	//only free shipping bar
	   		var onlyFreeAmt=parseInt($("#free-ship-only-amt").val());
	   		var onlyfreeShipping = parseInt((original_total_price/onlyFreeAmt)*100).toFixed(0);

	    	if(original_total_price<onlyFreeAmt){
	    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
	    		$('.only-free-ship.free-disc-amount').text(0);

	    		$('.only-free-ship.discount-ship > p').html(`You're only <span class="free-disc-amount" id="disc-amount">$${onlyFreeAmt-total}.00</span> away from <span>Free Shipping</span>`);

	    		setTimeout(function () {
	    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
	    			$(".only-free-ship .disc-th-point").addClass("active-point").show();
	    		}, 200);
	    		$('.only-free-ship .disc-progress-filled').removeClass('ship-fill-green');
	    		$(".only-free-ship .disc-tag svg path").css("fill", "#cb4b4b");

	    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
	    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
	    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
	    	}else{
	    		$(".only-free-ship .disc-main-bar").addClass("hasItems");
	    		$('.only-free-ship.free-disc-amount').text(0);

	    		$('.only-free-ship.discount-ship > p').html("YOU'VE UNLOCKED <span>FREE SHIPPING</span>");
	    		setTimeout(function () {
	    			$(".only-free-ship .disc-progress-filled").addClass("full-disc");
	    			$(".only-free-ship .disc-th-point").addClass("active-point").hide();
	    		}, 200);
	    		$('.only-free-ship .disc-progress-filled').addClass('ship-fill-green');
	    		$(".only-free-ship .disc-tag svg path").css("fill", "#39a33e");

	    		$('.only-free-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
	    		$(".only-free-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
    			$(".only-free-ship.discount-ship .progress-bar").addClass("ship-marg");
	    		$(".only-free-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
	    	}
	    	$('.only-free-ship .disc-progress-empty .disc-progress-filled').css('width',onlyfreeShipping+'%');
	    	$('.only-free-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+onlyfreeShipping);




	    	var free_amt = parseInt($("#cart-drawer #free-amt").val());
			var free_discount_amt = parseInt($("#cart-drawer #free-disc-amt").val());
			var discountCode = $("#cart-drawer #disc-code").val();
	    	var freeShipping = (original_total_price/free_amt)*100;

	    	if(original_total_price < free_amt){	
	    		$('.free-shipping-amount').text(free_amt - original_total_price);
	    		$('.shipping-bar > p').html('You\'re <span class="free-shipping-amount" id="ship-amount">$'+(free_amt - original_total_price)+'.00</span> away from <span id="ship-amount">'+free_discount_amt+'% OFF</span>');
				$('.progress-filled').addClass('ship-fill');
				$('.progress-filled').removeClass('ship-fill-green');
				$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").removeClass('active-green-point');
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#BD5450");
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#BD5450");				
	    	}else{
	    		$('.free-shipping-amount').text(0);
				$('.shipping-bar > p').html("You've Unlocked <span>"+free_discount_amt+"% OFF</span><br/>Use Code: <span class='discount-code'>"+discountCode+"</span>");
				$('.progress-filled').addClass('ship-fill-green');
				$('.progress-filled').removeClass('ship-fill');		
				$('.cart-shipping-bar.shipping-bar').find(".disc-th-point").addClass('active-green-point');
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.fill-svg').css("stroke", "#38ae3a");
				$('.cart-shipping-bar.shipping-bar').find('.disc-tag').find('path.dot-svg').css("fill", "#38ae3a");
	    	}
	    	$('.progress-empty .progress-filled').css('width',freeShipping+'%');


	    	//discount shipping bar
	    	var threshold_amt_2 = parseInt($("#cart-drawer #threshold-amt-2").val());
	    	var discount_amt = parseInt($("#cart-drawer #discount-amt").val());
	    	var discountShip = (original_total_price/threshold_amt_2)*100;

	    	var th1 = $("#cart-drawer #threshold-amt-1").val();
	    	var th2 = $("#cart-drawer #threshold-amt-2").val();
	    	

	    	if (original_total_price < threshold_amt_2){
	    		$('.free-disc-amount').text(threshold_amt_2 - original_total_price);
	    		$(".discount-ship .progress-bar").removeClass("ship-marg");
	    		$(".discount-ship .progress-bar").addClass("ship-marg-not");
	    		$(".discount-ship .disc-main-bar").css({"height":"33px", "border-radius" : "0px"});
	    		$(".disc-progress-filled").addClass("active-point");
	    		$('.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "visible");
	    		$(".disc-th-point").removeClass("active-point");
	    		$(".disc-progress-filled").removeClass("full-disc");
	    		$('.discount-ship > p').html('You\'re only <span class="free-disc-amount" id="disc-amount">$'+(threshold_amt_2 - original_total_price)+'</span> away from <span>'+discount_amt+'% Off</span>');

	    	}else{
	    		$('.only-discount-ship.free-disc-amount').text(0);

	    		$('.only-discount-ship.discount-ship > p').html('You got <span>'+discount_amt+'% Off</span> at checkout!');
	    		setTimeout(function () {
	    			$(".only-discount-ship.disc-progress-filled").addClass("full-disc");
	    			$(".only-discount-ship.disc-th-point").addClass("active-point");
	    		}, 200);

	    		$('.only-discount-ship.disc-progress-empty .disc-progress-filled .progress-marker').css("visibility", "hidden");
	    		$(".only-discount-ship.discount-ship .progress-bar").removeClass("ship-marg-not");
	    		$(".only-discount-ship.discount-ship .progress-bar").addClass("ship-marg");
	    		$(".only-discount-ship.discount-ship .disc-main-bar").css({"height":"13px", "border-radius" : "100px"});
	    	}


	    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled').css('width',discountShip+'%');
	    	$('.only-discount-ship .disc-progress-empty .disc-progress-filled .progress-marker').text('$'+discountShip);
	 	 },
	 	 
	 	 error: function(err){
	 	 	console.log(err);
	 	 }
	 })
}


cartDataCheckOnLoad();





// delete added product from cart

	function deleteProduct(id){
		$.ajax({
			type: 'POST',
	        url: '/cart/change.js',
	        dataType: 'json',
	        data: {
	            quantity: 0,
	            id: id
	        },
	        success: function (data){
				console.log('success');
	        },
	      	complete: function(){
	      		fetchproducts();
	      	},
	        error: function(error){
	        	console.log(error)
	        }
		});

	}

//cat page inc dec
$(window).on("load", function () {
	$(".td-cart-dec").on("click",function(event){
		let currentState = event.currentTarget.dataset.quantity;
		handleQuantity(currentState, event.target);
	});
	$(".td-cart-inc").on("click",function(event){
		let currentState = event.currentTarget.dataset.quantity;
		handleQuantity(currentState, event.target);
	});
});

// handleQuantity function to handle the quantity of product on cart
function handleQuantity(currentState, currTarget) {
	var inp = $(currTarget).siblings("input").val();
	if(currentState == 'plus') {			
		inp++;
		$(currTarget).siblings("input").val(inp);
		let quantity = document.querySelector(`[data-qty-${currTarget.dataset.index}]`).value;
		updateCart(currTarget.dataset.index, quantity);
	} else {
		inp--;
		$(currTarget).siblings("input").val(inp);
		let quantity = document.querySelector(`[data-qty-${currTarget.dataset.index}]`).value;
		updateCart(currTarget.dataset.index, quantity);
	}	
}

// update the cart project quantity
function updateCart(line, quantity) {
	document.querySelector(`[data-cart-item="${line}"]`).classList.add("item--loading");
 	const body = JSON.stringify({
	  line,
      quantity,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
	
	fetch(`/cart/change`, { ...fetchConfig(), ...{ body } })
	.then((response) => {
	  return response.text();
	})
	.then((state) => {
		const parsedState = JSON.parse(state);
		let itemCount = parsedState.item_count;
		document.querySelector(".header-cart-icon .count").innerText = itemCount;
		let clickEvent = new Event('click');
		getSectionsToRender().forEach((section) => {			
			const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
			elementToReplace.innerHTML = this.getSectionInnerHTML(
			  parsedState.sections[section.section],
			  section.selector
			);
			elementToReplace.querySelectorAll('.filled-cart form table tbody tr').forEach((ele) => {
				ele.classList.remove("item--loading");
				let inputQty = ele.querySelector('.td-qty').querySelectorAll('[data-qty-handle]');
				
				inputQty.forEach((qty) => {
					qty.addEventListener("click", (e) => {
						let currentState = e.currentTarget.dataset.quantity;
						handleQuantity(currentState, e.target);
					});
				});				
			});			
		  });
	})
	.catch((error) => {
		console.log('error', error);
      })
      .finally((final) => {
      });
}

function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}
function getSectionsToRender() {
    return [
      {
        id: 'cart-page',
        section: document.getElementById('cart-page').dataset.id,
        selector: '.js-contents',
      }
    ];
}
function fetchConfig(type = 'json') {
	return {
	  method: 'POST',
	  headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
}

	//collection page size swatches quick shop start

   function insertSwatches(){
	$("li.grid .collectSelect option").each(function(){
	    var option_value =$(this ).val();
	    var option_text = $(this).text();
	    var option_text1 = $(this).text();
	    var option_stock = $(this).attr("stock");
	   	if (option_text.includes(" / ")) {
	   		var option_value_split = option_text.split(" / ");
		    if (option_value_split[1] == "XSmall" || option_value_split[1] == "Xsmall" || option_value_split[1] == "xsmall" || option_value_split[1] == "xSmall") {
					option_value_split[1] = "XS";
		    }else if (option_value_split[1] == "Small" || option_value_split[1] == "small") {
	    		option_value_split[1] = "S";
	    	}else if(option_value_split[1] == "Medium" || option_value_split[1] == "medium"){
	    		option_value_split[1] = "M";
	    	}else if(option_value_split[1] == "Large" || option_value_split[1] == "large"){
	    		option_value_split[1] = "L";
	    	}else if(option_value_split[1] == "XLarge" || option_value_split[1] == "Xlarge" || option_value_split[1] == "xlarge" || option_value_split[1] == "xLarge"){
	    		option_value_split[1] = "XL";
	    	}else if(option_value_split[1] == "2XLarge" || option_value_split[1] == "2xlarge" || option_value_split[1] == "2xLarge" || option_value_split[1] == "2Xlarge"){
	    		option_value_split[1] = "2XL";
	    	}else if(option_value_split[1] == "3XLarge" || option_value_split[1] == "3xlarge" || option_value_split[1] == "3xLarge" || option_value_split[1] == "3Xlarge"){
	    		option_value_split[1] = "3XL";
	    	}else if(option_value_split[1] == "4XLarge" || option_value_split[1] == "4xlarge" || option_value_split[1] == "4xLarge" || option_value_split[1] == "4Xlarge"){
	    		option_value_split[1] = "4XL";
	    	}else if(option_value_split[1] == "5XLarge" || option_value_split[1] == "5xlarge" || option_value_split[1] == "5xLarge" || option_value_split[1] == "5Xlarge"){
	    		option_value_split[1] = "5XL";
	    	}else{
	    		option_value_split[1];
	    	}

	    	if ((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")) {
	    		var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-crew-tab");
	    		//on collection page
	    		$(sw_parent).append(`
	    			<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
	    				<span>${option_value_split[1]}</span>
	    			</div>
	    		`);
	    	}else if ((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")) {
	    		var sw_parent = $(this).parent().siblings(".pack-size-swatch-main").find(".swatch-v-neck-tab");
	    		//on collection page
	    		$(sw_parent).append(`
	    			<div variant-id="${option_value}" class="pack-product swatch-box ${option_stock}">
	    				<span>${option_value_split[1]}</span>
	    			</div>
	    		`);
	    	}
	    }
	});
   }
   insertSwatches();

	$(document).on("click",".quick-shop",function(){
		$(this).addClass("quick-shop-not-visible");
		$(this).siblings(".swatch-boxes-main").addClass("swatch-visible");

		$(this).siblings(".pack-boxes-swatch-main").addClass("swatch-visible");
		$(this).siblings(".legth-variant-main").addClass("swatch-visible");
	});

	//pack swatches quickshop
	$(document).on("click",".pack-boxes-swatch-main .pack-swatch",function(){
		// Check for active
		$(".pack-size-swatch-main").removeClass("swatch-visible");
		$(".pack-size-swatch-main .swatch-boxes-ul").removeClass("active-pack");
		$(this).parent().addClass("active-pack");

		// Display active tab
	    let currtab = $(this).attr("data-tab");

	    var pack_click = $(this).parent().parent().siblings(".pack-size-swatch-main").find(".swatch-"+currtab+"-tab");
	    $(this).parent().parent().siblings(".pack-size-swatch-main").children(".swatch-boxes-ul").hide();
	    $(this).parent().parent().siblings(".pack-size-swatch-main").addClass("swatch-visible");
	    $(this).parent().parent().siblings(".pack-size-swatch-main").find(".swatch-"+currtab+"-tab").show();
	    return false;
	});


	$(document).on('click', ".single-product, .pack-product", function(){
		var id = $(this).attr("variant-id");
		var membershipID = $(this).attr("membership-pack-id") || $(this).parent().attr("membership-pack-id");
		var freegiftID = $(this).attr('free-gift-id') || $(this).parent().attr('free-gift-id');
		if(membershipID){
			addtocart(id,1,membershipID);
		}
		else{
			if(freegiftID){
				addtocart(id,1,freegiftID);
			}
			else{
				addtocart(id, 1);
			}
		}
	});

	$(document).on('click',".single-product-length-variant", function(){	
		$(".length-variant-wrapper").addClass("swatch-visible");	
		let handle = $(this).attr("handle");	
		let size = $(this).attr("size");	
		window.globalselectedhandle = handle;	
		window.globalselectedSize = size;	
		let selectedProduct = [];	
		selectedProduct = window.globalProductObject.filter(d=>d.handle==window.globalselectedhandle);	
		let slectedVariant = selectedProduct[0].variants.filter(c=>c.option1==size);	
		console.log("slectedVariant",slectedVariant);	
		$(".length-variant").each(function(){	
			let length = $(this).attr("datalength");	
			$(this).removeClass("soldout");	
			let elem = slectedVariant.filter(k=>k.title == `${size} / ${length}` );	
			if(elem.length>0){	
				if(elem[0].available){	
				}	
				else{	
					$(this).addClass("soldout");	
				}	
			}	
		})	
	});	

	$(document).on('click',".length-variant",function(){	
		let datalength = $(this).attr("datalength");	
		let selectedProduct = window.globalProductObject.filter(d=>d.handle==window.globalselectedhandle);	
		let slectedVariant;	
		if(selectedProduct.length>0){	
			slectedVariant = selectedProduct[0].variants.filter(c=>c.title==`${window.globalselectedSize} / ${datalength}`);	
			addtocart(slectedVariant[0].id, 1);	
		}	
	})

	$(document).on("mouseleave","li.grid",function(){
		$(this).find(".quick-shop").removeClass("quick-shop-not-visible");
		$(this).find(".swatch-boxes-main").removeClass("swatch-visible");

		$(".legth-variant-main").removeClass("swatch-visible");	
		$(".length-variant-wrapper").removeClass("swatch-visible");

		$(".pack-size-swatch-main .swatch-crew-tab").addClass("active-pack");
		$(".pack-size-swatch-main").removeClass("swatch-visible");
		$(".pack-size-swatch-main .swatch-v-neck-tab").hide();
		$(this).find(".pack-boxes-swatch-main").removeClass("swatch-visible");
	});
	//collection page size swatches quick shop end

	/*cart drawer recommended start*/
	$(".select-dropdown .select-selected").on("click", function(e){
		e.stopPropagation();
       $(this).closest('.cart-item-box').siblings('.cart-item-box').find('.select-items').addClass("select-hide");
		if($(this).siblings(".select-items").is(':visible')){
			$(this).siblings(".select-items").addClass("select-hide");
		}else{
			$(this).siblings(".select-items").removeClass("select-hide");	
		}

	});

	$(document).on("click", function(e){
		e.stopPropagation();
		$(".select-items").addClass("select-hide");
	});

	var var_id = "";
	$(".select-items div").on("click", function(){
		var text = $(this).text();
		var_id = $(this).attr("value");

		$(".select-items div").each(function(){
			if($(this).hasClass("same-as-selected")){
				$(this).removeClass("same-as-selected");
			}
		});
		$(this).addClass("same-as-selected");
		$(this).parent().siblings(".select-selected").text(text).attr("variant-id", var_id);
		$(this).parent().addClass("select-hide");

		$(this).parent().parent().siblings(".select-size").children(".select-size-btn").hide();
		$(this).parent().parent().siblings(".select-size").children(".select-add-btn").text("Add To Cart").css({"background-color":"#242424", "border-color": "#242424"});
		$(this).parent().parent().siblings(".select-size").children(".select-add-btn").show();
		return false;
	});

	$(".select-add-btn").on('click', function(e){
		e.preventDefault();
		addtocart(var_id, 1);
		$(this).html('<span class="check-svg"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.99826.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" fill="currentColor"></path></svg></span><span>Added To Cart</span>').css({"background-color":"#8D8D8C", "border-color": "#8D8D8C"});
	});
	/*cart drawer recommended end*/

	/*pdp sticky bar start*/
	$(document).on('click', "button.sticky-scroll",function(){
	    var offTop = $("#product").offset().top;
		$('html,body').animate({
			scrollTop: offTop
		},500);
	});
	$(document).on('click', "button.sticky-cart",function(){
		$("button[type='submit'].btn-ajaxcart").click();

	});
	/*pdp sticky bar end*/

	//stratusoft, fresh clean seas slider
	$(".ul-future").slick({
		slidesToShow: 1,
	  	slidesToScroll: 1,
	  	dots: true,
	  	arrows: false,
	  	infinite: true
	});

	//klaviyo newsletter start
	$("#email_signup #email-address").on('input', function(){
		var email = $.trim($("#email-address").val());
		if(email.length > 0){
			$(this).parent().siblings('button').addClass('btn-active');
		}else{
			$(this).parent().siblings('button').removeClass('btn-active');
		}
	});

	$('#email_signup button').on('click', function(){
		var email = $.trim($("#email-address").val());
		var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
		if(!pattern.test(email)){
			$("#email-error").text("Invalid Email Address").css("color", "#cb4b4b");
			$("#email-error").show();
		}
	});
	//klaviyo newsletter end

	/*generate swatches from select box start*/
	var option = $(".allSelect option:selected").attr("stock");

	var temp_length="";	
	var globalVariantDetails = [];	
	window.globalVariantDetails = globalVariantDetails;	
	// trigger click event on reegular variant button

	$(".allSelect option").each(function(){
	    var option_value = $(this).val();
	    var option_text = $(this).text();
	    var option_text1 = $(this).text();
	    var option_stock = $(this).attr("stock");
	    var variant_price = $(this).attr("variant-price");
	    var variant_compare = $(this).attr("variant-compare");
		let variant = {	
			option_value: option_value,	
			option_text : option_text,	
			option_stock : option_stock,	
			variant_price : variant_price,	
			variant_compare : variant_compare	
		}	
		globalVariantDetails.push(variant)	
	    // console.log(option_value,".......", option_text,".......",option_text1,".......",option_stock,".......",variant_price,".......",variant_compare);

	    if (option_text == "XSmall" || option_text == "Xsmall" || option_text == "xsmall" || option_text == "xSmall") {
				option_text = "XS";
			}else if(option_text == "Small" || option_text == "small") {
    		option_text = "S";
    	}else if(option_text == "Medium" || option_text == "medium"){
    		option_text = "M";
    	}else if(option_text == "Large" || option_text == "large"){
    		option_text = "L";
    	}else if(option_text == "XLarge" || option_text == "Xlarge" || option_text == "xlarge" || option_text == "xLarge"){
    		option_text = "XL";
    	}else if(option_text == "2XLarge" || option_text == "2xlarge" || option_text == "2xLarge" || option_text == "2Xlarge"){
    		option_text = "2XL";
    	}else if(option_text == "3XLarge" || option_text == "3xlarge" || option_text == "3xLarge" || option_text == "3Xlarge"){
    		option_text = "3XL";
    	}else if(option_text == "4XLarge" || option_text == "4xlarge" || option_text == "4xLarge" || option_text == "4Xlarge"){
    		option_text = "4XL";
    	}else if(option_text == "5XLarge" || option_text == "5xlarge" || option_text == "5xLarge" || option_text == "5Xlarge"){
    		option_text = "5XL";
    	}else{
    		option_text;
    	}
	   
	   	if (option_text.includes(" / ")) {
	   		var option_value_split = option_text.split(" / ");

		    if (option_value_split[0] == "XSmall" || option_value_split[0] == "Xsmall" || option_value_split[0] == "xsmall" || option_value_split[0] == "xSmall") {
			    option_text = "XS";
	      }else if(option_value_split[0] == "Small" || option_value_split[0] == "small") {
	    		option_value_split[1] = "S";	
	    	}else if(option_value_split[0] == "Medium" || option_value_split[0] == "medium"){	
	    		option_value_split[1] = "M";	
	    	}else if(option_value_split[0] == "Large" || option_value_split[0] == "large"){	
	    		option_value_split[1] = "L";	
	    	}else if(option_value_split[0] == "XLarge" || option_value_split[0] == "Xlarge" || option_value_split[0] == "xlarge" || option_value_split[0] == "xLarge"){	
	    		option_value_split[1] = "XL";	
	    	}else if(option_value_split[0] == "2XLarge" || option_value_split[0] == "2xlarge" || option_value_split[0] == "2xLarge" || option_value_split[0] == "2Xlarge"){	
	    		option_value_split[1] = "2XL";	
	    	}else if(option_value_split[0] == "3XLarge" || option_value_split[0] == "3xlarge" || option_value_split[0] == "3xLarge" || option_value_split[0] == "3Xlarge"){	
	    		option_value_split[1] = "3XL";	
	    	}else if(option_value_split[0] == "4XLarge" || option_value_split[0] == "4xlarge" || option_value_split[0] == "4xLarge" || option_value_split[0] == "4Xlarge"){	
	    		option_value_split[1] = "4XL";	
	    	}else if(option_value_split[0] == "5XLarge" || option_value_split[0] == "5xlarge" || option_value_split[0] == "5xLarge" || option_value_split[0] == "5Xlarge"){
	    		option_value_split[1] = "5XL";
	    	}else{
	    		option_value_split[1];
	    	}

	    	var swatch_name = option_text.split(" / ");
			let size ="";
		    if (swatch_name[1] == "XSmall" || swatch_name[1] == "Xsmall" || swatch_name[1] == "xsmall" || swatch_name[1] == "xSmall") {
					swatch_name[1] = "XSmall";
				size = "XS";
		    }else if(swatch_name[1] == "Small" || swatch_name[1] == "small") {
	    		swatch_name[1] = "Small";
				size = "S";
	    	}else if(swatch_name[1] == "Medium" || swatch_name[1] == "medium"){
	    		swatch_name[1] = "Medium";
				size = "M";
	    	}else if(swatch_name[1] == "Large" || swatch_name[1] == "large"){
	    		swatch_name[1] = "Large";
				size = "L";
	    	}else if(swatch_name[1] == "XLarge" || swatch_name[1] == "Xlarge" || swatch_name[1] == "xlarge" || swatch_name[1] == "xLarge"){
	    		swatch_name[1] = "XLarge";
				size = "XL";
	    	}else if(swatch_name[1] == "2XLarge" || swatch_name[1] == "2xlarge" || swatch_name[1] == "2xLarge" || swatch_name[1] == "2Xlarge"){
	    		swatch_name[1] = "2XLarge";
				size = "2XL";
	    	}else if(swatch_name[1] == "3XLarge" || swatch_name[1] == "3xlarge" || swatch_name[1] == "3xLarge" || swatch_name[1] == "3Xlarge"){
	    		swatch_name[1] = "3XLarge";
				size = "3XL";
	    	}else if(swatch_name[1] == "4XLarge" || swatch_name[1] == "4xlarge" || swatch_name[1] == "4xLarge" || swatch_name[1] == "4Xlarge"){
	    		swatch_name[1] = "4XLarge";
				size = "4XL";
	    	}else if(swatch_name[1] == "5XLarge" || swatch_name[1] == "5xlarge" || swatch_name[1] == "5xLarge" || swatch_name[1] == "5Xlarge"){
	    		swatch_name[1] = "5XLarge";
				size = "5XL";
	    	}else{
	    		swatch_name[1];
	    	}

	    	if((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")){
	    		$(".swatches-div .neck-size-parent .crew-tab").append(`
	    			<div data-value="${swatch_name[1]}" class="swatch-element ${option_stock}">
	    				<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-crew-${swatch_name[1].toLowerCase()}" type="radio" name="option-1" value="${swatch_name[1]}" />
	    				<label radio-value="Neck Style" for="swatch-crew-${swatch_name[1].toLowerCase()}" class="size-label">${size}</label>
	    			</div>
	    		`);

	    		//on collection page
			}
			else if((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")){
				$(".swatches-div .neck-size-parent .v-neck-tab").append(`
					<div data-value="${swatch_name[1]}" class="swatch-element ${option_stock}">
						<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-v-neck-${swatch_name[1].toLowerCase()}" type="radio" name="option-1" value="${swatch_name[1]}" />
						<label radio-value="Neck Style" for="swatch-v-neck-${swatch_name[1].toLowerCase()}" class="size-label">${size}</label>
					</div>
				`);
		   
			}
			else{
				var optionl_text2 = option_value_split[1] ? option_value_split[0] : option_text1;
				if(temp_length != optionl_text2){
					$(".swatches-div .swatch-parent").append(`
						<div data-value="${option_value_split[1] ? option_value_split[0] : option_text1}" class="swatch-element ${option_value_split[1] ? option_value_split[0] : option_text1} ${option_stock}">
							<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-${option_value_split[1] ? option_value_split[0].toLowerCase() : option_text1.toLowerCase()}" type="radio" name="option-0" value="${option_value_split[1] ? option_value_split[0] : option_text1}" />
							<label radio-value="Size" for="swatch-${option_value_split[1] ? option_value_split[0].toLowerCase() : option_text1.toLowerCase()}" class="size-label">${option_value_split[1] ? option_value_split[1] : option_text1}</label>
						</div>
					`);
					temp_length = option_value_split[1] ? option_value_split[0] : option_text1;
				}
			}
	    }
		else{
			$(".swatches-div .swatch-parent").append(`
				<div data-value="${option_text1}" class="swatch-element ${option_text1.toLowerCase()} ${option_stock}">
					<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-${option_text1.toLowerCase()}" type="radio" name="option-0" value="${option_text1}" />
					<label radio-value="Size" for="swatch-${option_text1.toLowerCase()}" class="size-label">${option_text}</label>
				</div>
			`);
		}
	});
	/*generate swatches from select box end*/
	window.globalcreateSizeOption = 

	function createSizeOption(){
		/*generate swatches from select box start*/
		let temp_length="";	
		let globalVariantDetails = [];	
		window.globalVariantDetails = globalVariantDetails;	
		// trigger click event on reegular variant button
	
		$(".allSelect option").each(function(){
			var option_value = $(this).val();
			var option_text = $(this).text();
			var option_text1 = $(this).text();
			var option_stock = $(this).attr("stock");
			var variant_price = $(this).attr("variant-price");
			var variant_compare = $(this).attr("variant-compare");
			let variant = {	
				option_value: option_value,	
				option_text : option_text,	
				option_stock : option_stock,	
				variant_price : variant_price,	
				variant_compare : variant_compare	
			}	
			globalVariantDetails.push(variant)

			if (option_text == "XSmall" || option_text == "Xsmall" || option_text == "xsmall" || option_text == "xSmall") {
		    option_text = "XS";
			}else if(option_text == "Small" || option_text == "small") {
				option_text = "S";
			}else if(option_text == "Medium" || option_text == "medium"){
				option_text = "M";
			}else if(option_text == "Large" || option_text == "large"){
				option_text = "L";
			}else if(option_text == "XLarge" || option_text == "Xlarge" || option_text == "xlarge" || option_text == "xLarge"){
				option_text = "XL";
			}else if(option_text == "2XLarge" || option_text == "2xlarge" || option_text == "2xLarge" || option_text == "2Xlarge"){
				option_text = "2XL";
			}else if(option_text == "3XLarge" || option_text == "3xlarge" || option_text == "3xLarge" || option_text == "3Xlarge"){
				option_text = "3XL";
			}else if(option_text == "4XLarge" || option_text == "4xlarge" || option_text == "4xLarge" || option_text == "4Xlarge"){
				option_text = "4XL";
			}else if(option_text == "5XLarge" || option_text == "5xlarge" || option_text == "5xLarge" || option_text == "5Xlarge"){
				option_text = "5XL";
			}else{
				option_text;
			}
		   
			   if (option_text.includes(" / ")) {
				   var option_value_split = option_text.split(" / ");

			  if (option_value_split[0] == "XSmall" || option_value_split[0] == "Xsmall" || option_value_split[0] == "xsmall" || option_value_split[0] == "xSmall") {
					option_text = "XS";
	      }else if(option_value_split[0] == "Small" || option_value_split[0] == "small") {
					option_value_split[1] = "S";	
				}else if(option_value_split[0] == "Medium" || option_value_split[0] == "medium"){	
					option_value_split[1] = "M";	
				}else if(option_value_split[0] == "Large" || option_value_split[0] == "large"){	
					option_value_split[1] = "L";	
				}else if(option_value_split[0] == "XLarge" || option_value_split[0] == "Xlarge" || option_value_split[0] == "xlarge" || option_value_split[0] == "xLarge"){	
					option_value_split[1] = "XL";	
				}else if(option_value_split[0] == "2XLarge" || option_value_split[0] == "2xlarge" || option_value_split[0] == "2xLarge" || option_value_split[0] == "2Xlarge"){	
					option_value_split[1] = "2XL";	
				}else if(option_value_split[0] == "3XLarge" || option_value_split[0] == "3xlarge" || option_value_split[0] == "3xLarge" || option_value_split[0] == "3Xlarge"){	
					option_value_split[1] = "3XL";	
				}else if(option_value_split[0] == "4XLarge" || option_value_split[0] == "4xlarge" || option_value_split[0] == "4xLarge" || option_value_split[0] == "4Xlarge"){	
					option_value_split[1] = "4XL";	
				}else if(option_value_split[0] == "5XLarge" || option_value_split[0] == "5xlarge" || option_value_split[0] == "5xLarge" || option_value_split[0] == "5Xlarge"){
					option_value_split[1] = "5XL";
				}else{
					option_value_split[1];
				}
	
				var swatch_name = option_text.split(" / ");
				let size ="";

				if (swatch_name[1] == "XSmall" || swatch_name[1] == "Xsmall" || swatch_name[1] == "xsmall" || swatch_name[1] == "xSmall") {
					swatch_name[1] = "XSmall";
					size = "XS";
				}else if(swatch_name[1] == "Small" || swatch_name[1] == "small") {
					swatch_name[1] = "Small";
					size = "S";
				}else if(swatch_name[1] == "Medium" || swatch_name[1] == "medium"){
					swatch_name[1] = "Medium";
					size = "M";
				}else if(swatch_name[1] == "Large" || swatch_name[1] == "large"){
					swatch_name[1] = "Large";
					size = "L";
				}else if(swatch_name[1] == "XLarge" || swatch_name[1] == "Xlarge" || swatch_name[1] == "xlarge" || swatch_name[1] == "xLarge"){
					swatch_name[1] = "XLarge";
					size = "XL";
				}else if(swatch_name[1] == "2XLarge" || swatch_name[1] == "2xlarge" || swatch_name[1] == "2xLarge" || swatch_name[1] == "2Xlarge"){
					swatch_name[1] = "2XLarge";
					size = "2XL";
				}else if(swatch_name[1] == "3XLarge" || swatch_name[1] == "3xlarge" || swatch_name[1] == "3xLarge" || swatch_name[1] == "3Xlarge"){
					swatch_name[1] = "3XLarge";
					size = "3XL";
				}else if(swatch_name[1] == "4XLarge" || swatch_name[1] == "4xlarge" || swatch_name[1] == "4xLarge" || swatch_name[1] == "4Xlarge"){
					swatch_name[1] = "4XLarge";
					size = "4XL";
				}else if(swatch_name[1] == "5XLarge" || swatch_name[1] == "5xlarge" || swatch_name[1] == "5xLarge" || swatch_name[1] == "5Xlarge"){
					swatch_name[1] = "5XLarge";
					size = "5XL";
				}else{
					swatch_name[1];
				}
	
				if((option_value_split[0] === "crew") || (option_value_split[0] === "Crew")){
					$(".swatches-div .neck-size-parent .crew-tab").append(`
						<div data-value="${swatch_name[1]}" class="swatch-element ${option_stock}">
							<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-crew-${swatch_name[1].toLowerCase()}" type="radio" name="option-1" value="${swatch_name[1]}" />
							<label radio-value="Neck Style" for="swatch-crew-${swatch_name[1].toLowerCase()}" class="size-label">${size}</label>
						</div>
					`);

				}
				else if((option_value_split[0] === "v-neck") || (option_value_split[0] === "V-Neck") || (option_value_split[0] === "V-neck") || (option_value_split[0] === "v-Neck")){
					$(".swatches-div .neck-size-parent .v-neck-tab").append(`
						<div data-value="${swatch_name[1]}" class="swatch-element ${option_stock}">
							<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-v-neck-${swatch_name[1].toLowerCase()}" type="radio" name="option-1" value="${swatch_name[1]}" />
							<label radio-value="Neck Style" for="swatch-v-neck-${swatch_name[1].toLowerCase()}" class="size-label">${size}</label>
						</div>
					`);
			   
				}
				else{
					var optionl_text2 = option_value_split[1] ? option_value_split[0] : option_text1;
					if(temp_length != optionl_text2){
						$(".swatches-div .swatch-parent").append(`
							<div data-value="${option_value_split[1] ? option_value_split[0] : option_text1}" class="swatch-element ${option_value_split[1] ? option_value_split[0] : option_text1} ${option_stock}">
								<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-${option_value_split[1] ? option_value_split[0].toLowerCase() : option_text1.toLowerCase()}" type="radio" name="option-0" value="${option_value_split[1] ? option_value_split[0] : option_text1}" />
								<label radio-value="Size" for="swatch-${option_value_split[1] ? option_value_split[0].toLowerCase() : option_text1.toLowerCase()}" class="size-label">${option_value_split[1] ? option_value_split[1] : option_text1}</label>
							</div>
						`);
						temp_length = option_value_split[1] ? option_value_split[0] : option_text1;
					}
				}
			}
			else{
				$(".swatches-div .swatch-parent").append(`
					<div data-value="${option_text1}" class="swatch-element ${option_text1.toLowerCase()} ${option_stock}">
						<input variant-price="${variant_price}" variant-compare="${variant_compare}" variant-id="${option_value}" id="swatch-${option_text1.toLowerCase()}" type="radio" name="option-0" value="${option_text1}" />
						<label radio-value="Size" for="swatch-${option_text1.toLowerCase()}" class="size-label">${option_text}</label>
					</div>
				`);
			}
		});
	};

	/*generate swatches tab start*/
	$(".neck-parent input[type='radio']").change(function() {
		// Check for active
	    $(".neck-size-parent .swatch-parent").removeClass("active-swatch");
	    $(this).parent().addClass("active-swatch");

	    // Display active tab
	    let currtab = $(this).parent().attr("data-value");

	    $(".neck-size-parent .swatch-parent").hide();
	    $("."+currtab+"-tab").show();
	    return false;
	});
	/*generate swatches tab end*/


	/*cookie size select start*/
	function setCookie(name,value,days) {
	    var expires = "";
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + (days*24*60*60*1000));
	        expires = "; expires=" + date.toUTCString();
	    }
	    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}
	function getCookie(name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0;i < ca.length;i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1,c.length);
	        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	    }
	    return null;
	}


	var size_swatch = getCookie("size-swatch");
	var dataval = "";
	var button_element = $("button[type='submit'].add-to-cart");

	$(document).on("change",".size-parent .swatch-element input:radio[name=option-0]",function(){
	    val = $(this).val();
	    if (val) {
	    	$(".size-swatch-name").text(val);

	    	setCookie("size-swatch", val, 1); //set "size-swatch" cookie, expires in 1 day

	    	dataval = $(this).parent().attr("data-value");
	    	var check = $(this).attr('checked', true);
	    }
	});

	//gift card product
	var gift_price = $(".gift-card-only .swatch-element.available:first input:radio[name=option-0]").attr("variant-price");
	$(".col-45 li label.price, #sticky-product .addcart-price span.single-price, .col-55 li label.price").text(gift_price);

	$(document).on("change",".gift-card-only .swatch-element.available input:radio[name=option-0]",function(){
	    val = $(this).val();
	    if (val) {
	    	$(".gift-swatch-name").text(val);
	    }

	    //change price & slide based on denomination
	    var gift_price = $(this).attr("variant-price");
	    $(".col-45 li label.price, #sticky-product .addcart-price span.single-price, .col-55 li label.price").text(gift_price);

        var slideno = $(this).parent().index();
        var slider = $(".thumbnail-slider");
        $(".thumbnail-slider .thumb[data-slick-index='"+slideno+"']").click();
	});

	//product page varaint default checker
	var swatchValue = $(".size-parent .swatch-element.available input:radio[name=option-0]:checked").val();

	if (size_swatch != null) {
		if ($(".size-parent .swatch-element input:radio[name=option-0][value="+size_swatch+"]")) {
			$($(".size-parent .swatch-element input:radio[name=option-0][value="+size_swatch+"]")).siblings("label").click();
			$(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]").attr("checked", true);
			$(".size-swatch-name").text(size_swatch);

			var variant_id = $(".size-parent .swatch-element.available input:radio[name=option-0][value="+size_swatch+"]").attr("checked", true).attr("variant-id");
			$(".productSelect").val(variant_id);
		}
	}
	if ($(".swatch-element input:radio[name=option-0]:checked").val() != $(".size-swatch-name").text()) {

		$(".size-swatch-name").text("");
	}

	/*cookie size select end*/


	/*pdp swatches click show button text start*/
	
	if ($(".size-parent .swatch-element.available input[type='radio']:checked").length > 0){
		button_element.text("Add To Cart").removeAttr("disabled");
		//pdp sticky add to cart
		$("button.sticky-scroll").hide();
		$("button.sticky-cart").show();
	} else if($(".size-parent .swatch-element.soldout input[type='radio']:checked").length > 0){
		button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
		$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
		$("button.sticky-cart").hide();
	}

	// single product size swatches
	$(document).on("change", ".size-parent input[type='radio'], .gift-card-only input[type='radio']",function() {
		$('.swatch_box').removeClass('size-not-available')
		var current = $(this);
		var product_url = window.location.href.split('?')[0];
		var variant_id = "";
		var target_url = "";
		var selVal = $(this).val();
		let button_element = $("button[type='submit'].add-to-cart");
		let membership_data = $(".price-review label.price").attr("data-metafield-prod-id");
		if (($(".size-parent input[type='radio']:checked").length > 0) || ($(".gift-card-only input[type='radio']:checked").length > 0)){
			var variant_price = $(this).attr("variant-price");
			var variant_compare = $(this).attr("variant-compare");
			if (variant_compare == "undefined"){
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").removeClass("compare-price");

				$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del, #sticky-product .title-color span.price del").remove();

				if(!membership_data){
					$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span, #sticky-product .title-color span.price span").text(variant_price);
				}
			}else{
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").addClass("compare-price");
				
				if(!membership_data){
					$(".col-45 li label.price, .col-55 li label.price, #sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
	
					//desktop
					$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>");
	
					//mobile
					$("#sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
				}
			}

			// var notAvl = window.productsArray.filter(prod => prod.variants)

			$(window.productsArray).each((i,prod) => {
				$(prod.variants).each((j,variant) => {
					if(variant.option1 == selVal && variant.available == false){ // find the variant that does not have the stock
						
						$('.swatch_box[handle="'+prod.handle+'"]').addClass('size-not-available')
					}

				})
			})
			//checking soldout varaint
			if($(".length_wise_swatch_list").length==0){
				console.log("working...11")
				if ($(".size-parent .swatch-element.soldout input[type='radio']:checked").length > 0){
					console.log("soldout variant");
					button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
					$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
					$("button.sticky-cart").hide();
				}else if($(".size-parent .swatch-element.available input[type='radio']:checked").length > 0 || $(".gift-card-only .swatch-element.available input[type='radio']:checked").length > 0){
	
					console.log("available variant");
					button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
					$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
					$("button.sticky-cart").show();
				}
			}
			else if($(".length_wise_swatch_list").length>0){
				if($(".size-parent .swatch-element.soldout input[type='radio']:checked").length > 0){
					console.log("soldout variant23",$("button[type='submit'].add-to-cart"));
					button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
					$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
					$("button.sticky-cart").hide();
				}else if($(".size-parent .swatch-element.available input[type='radio']:checked").length > 0){
					console.log("available variant2");
					
					button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
					$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
					$("button.sticky-cart").show();
				}
			}

			var variant_id = current.attr("variant-id");
			$(".productSelect").val(variant_id);
			target_url = product_url+"?variant="+variant_id;
		}
		window.history.pushState({url: target_url},'', target_url);
	});

	//neck-size swatches
	$(document).on("change",".neck-parent input[type='radio']",function() {
		$(".neck-swatch-name").text($(this).val());
		button_element.text("Select Size");
		console.log("nexk-pren88")
	});

	$(document).on("change",".neck-size-parent input[type='radio']",function() {
		$('.swatch_box').removeClass('size-not-available');

		var current = $(this);
		var product_url = window.location.href.split('?')[0];
		var variant_id = "";
		var target_url = "";
		var val = $(this).val();
		console.log("val",val);
		let button_element = $("button[type='submit'].add-to-cart");
		$(".neck-size-name,.size-swatch-name").text(val);

		$(window.productsArray).each((i,prod) => {
			$(prod.variants).each((j,variant) => {
				if(variant.option1 == val && variant.available == false){ // find the variant that does not have the stock
					
					$('.swatch_box[handle="'+prod.handle+'"]').addClass('size-not-available')
				}

			})
		})

		$(".length-wise-swatch [data-value=Regular]").removeClass("checked_length");	
		$(".length_wise_swatch_list .length-wise-swatch .swatch-element").each(function(){	
			let size = $(".neck-size-name").text() || $(".size-swatch-name").text() ;	
			let length = $(this).attr("data-value");	
			let variantdetail = window.globalVariantDetails;	
			let filteredDetail = variantdetail.filter(c=>c.option_text==`${size} / ${length}`);	
			let selectedLength = $(".selected_length").text();
			console.log("filteredDetail",filteredDetail);	
			if(filteredDetail.length>0){	
				if(filteredDetail[0].option_stock=="available"){	
					$(this).removeClass("soldout");	
					$(this).addClass("available");	
					if(filteredDetail[0].option_text.includes(selectedLength)){	
						$(this).removeClass("selectedvariant_soldout");	
						$(this).addClass("selectedvariant_available");	
					}	
					else{	
						$(this).removeClass("selectedvariant_available");	
					}	
				}	
				else{	
					$(this).removeClass("available");	
					$(this).addClass("soldout");	
					if(filteredDetail[0].option_text.includes(selectedLength)){	
						$(this).removeClass("selectedvariant_available");	
						$(this).addClass("selectedvariant_soldout");	
					}	
					else{	
						$(this).removeClass("selectedvariant_soldout");	
					}	
				}	
			}	
		})
			
		if ($(".neck-size-parent input[type='radio']:checked").length > 0){
			$("button.sticky-scroll").text("Select Size");
			var variant_id = current.attr("variant-id");
			$(".productSelect").val(variant_id);
			target_url = product_url+"?variant="+variant_id;
		}

		//checking soldout varaint

		if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
			console.log("soldout variant length");
			button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
			$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
			$("button.sticky-cart").hide();
		}else{
			console.log("available variant length");
			button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
			$("button.sticky-cart").show();
		}
		

		window.history.pushState({url: target_url},'', target_url);

	});
	/*pdp swatches click show button text end*/	

	// selected Length on pdp	
	$(document).on('change',".length-wise-swatch input[type='radio']",function(){	
	
			var current = $(this);	
			var product_url = window.location.href.split('?')[0];	
			var variant_id = "";	
			var target_url = "";	
			var val = $(this).val();	
			$(".length-wise-swatch [data-value=Regular]").removeClass("checked_length");	
			$(".length-wise-swatch [data-value=Regular] label").removeClass("selectedLabel");	
			$(".selected_length").text(val);	
					
			if ($(".neck-size-parent input[type='radio']:checked").length == 0){	
	
				$("button.sticky-scroll").text("Select Size");	
				var variant_id = current.attr("variant-id");	
				$(".productSelect").val(variant_id);	
				target_url = product_url+"?variant="+variant_id;	
			}	
			let Size = $(".neck-size-name").text() || $(".size-swatch-name").text();	
			console.log("Size",Size);	
			
			checkSoldoutVariant(val);	
			// window.history.pushState({url: target_url},'', target_url);	
		});	
		function checkSoldoutVariant(length){	
			let button_element = $("button[type='submit'].add-to-cart");
			$(".neck-size-parent .swatch-parent .swatch-element").each(function(){	
				let size = $(this).attr("data-value");	
				let variantdetail = window.globalVariantDetails;	
				let filteredDetail = variantdetail.filter(c=>c.option_text==`${size} / ${length}`);
				if(filteredDetail.length>0){	
					if(filteredDetail[0].option_stock=="available"){	
						$(this).removeClass("soldout");	
						$(this).addClass("available");	
					}	
					else{	
						$(this).removeClass("available");	
						$(this).addClass("soldout");	
					}	
				}	
				$(".length_wise_swatch_list .length-wise-swatch .swatch-element").each(function(){	
					let size = $(".neck-size-name").text() || $(".size-swatch-name").text();	
					let length = $(this).attr("data-value");	
			
					let variantdetail = window.globalVariantDetails;	
					let filteredDetail = variantdetail.filter(c=>c.option_text==`${size} / ${length}`);	
					let selectedLength = $(".selected_length").text();	
					if(filteredDetail.length>0){	
						if(filteredDetail[0].option_stock=="available"){	

							if(filteredDetail[0].option_text.includes(selectedLength)){	
								$(this).removeClass("selectedvariant_soldout");	
								$(this).addClass("selectedvariant_available");	
							}	
							else{
								$(this).removeClass("selectedvariant_soldout");	
								$(this).removeClass("selectedvariant_available");	
							}	
						}	
						else{
	
							if(filteredDetail[0].option_text.includes(selectedLength)){	
								$(this).removeClass("selectedvariant_available");	
								$(this).addClass("selectedvariant_soldout");	
							}	
							else{
								$(this).removeClass("selectedvariant_available");		
								$(this).removeClass("selectedvariant_soldout");	
							}	
						}	
					}	
				});	
						
						// checking soldout varaint	
				if ($(".neck-size-parent .swatch-element.soldout input[type='radio']:checked").length > 0){	
					console.log("soldout variant");	
					button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");	
					$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();	
					$("button.sticky-cart").hide();	
				}else if($(".neck-size-parent .swatch-element.available input[type='radio']:checked").length > 0){	
					console.log("available variant");	
					button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");	
					$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();	
					$("button.sticky-cart").show();	
				}	
				else if($(".neck-size-parent .swatch-element input[type='radio']:checked").length == 0){	
					console.log("no variant");	
					button_element.text("Select Size").attr("disabled", "disabled");	
					$("button.sticky-scroll").text("Select Size").attr("disabled", "disabled").show();	
					$("button.sticky-cart").hide();	
				}	
			});	
		}	
		// automatically select regular length	
		$(document).ready(function(){	
			if($(".length-wise-swatch").length>0){	
				$(".selected_length").text("Regular");	
				$(".length-wise-swatch [data-value=Regular]").addClass("checked_length");	
				$(".length-wise-swatch [data-value=Regular] label").addClass("selectedLabel");	
				$(".qty-add .add-to-cart").text("Select Size");
				$("button.sticky-scroll").text("Select Size").removeAttr("disabled").show();	
			}
			document.querySelectorAll(".color-variant-div").forEach(function(e){
				if(!e.querySelector(".color-divs a")){
					e.style.display = "none";
				}
			})
		})

		$(document).on("click",".color-variant-div",function(){
			document.querySelectorAll(".color-variant-div").forEach(function(e){
				if(!e.querySelector(".color-divs a")){
					e.style.display = "none";
				}
			})
		})

	/*neck,size tab radios button text change start*/
	$(".only-neck-size input[type='radio']").change(function() {
		if (($(".neck-parent .crew input[type='radio']:checked").length == 0)){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}else if(($(".neck-parent .v-neck input[type='radio']:checked").length == 0)){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}

		if (($(".neck-size-parent .crew-tab input[type='radio']:checked").length > 0) && ($(".neck-parent .crew input[type='radio']:checked").length == 0)){
			button_element.text("Select Neck Style").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Neck Style").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}else if(($(".neck-size-parent .v-neck-tab input[type='radio']:checked").length > 0) && ($(".neck-parent .v-neck-tab input[type='radio']:checked").length == 0)){
			button_element.text("Select Neck Style").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Neck Style").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}

		if ($(".neck-parent .crew input[type='radio']:checked").length > 0){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}else if ($(".neck-parent .v-neck input[type='radio']:checked").length > 0){
			button_element.text("Select Size").attr("disabled", "disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn");
			$("button.sticky-scroll").show();
			$("button.sticky-cart").hide();
		}

		var variant_price = $(this).attr("variant-price");
		var variant_compare = $(this).attr("variant-compare");

		if (($(".neck-parent .crew input[type='radio']:checked").length > 0) && ($(".neck-size-parent .crew-tab input[type='radio']:checked").length > 0)){

			let variant_price = $(".neck-size-parent .crew-tab input[type='radio']:checked").attr("variant-price");	
			let variant_compare = $(".neck-size-parent .crew-tab input[type='radio']:checked").attr("variant-compare");
			if (variant_compare == "undefined"){
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").removeClass("compare-price");

				$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del, #sticky-product .title-color span.price del").remove();

				$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span, #sticky-product .title-color span.price span").text(variant_price);
			}else{
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").addClass("compare-price");
				
				$(".col-45 li label.price, .col-55 li label.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");

				//desktop
				$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>");

				//mobile
				$("#sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
			}

			if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
				button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
				$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
				$("button.sticky-cart").hide();
			}else{
				button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
				$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
				$("button.sticky-cart").show();
			}

		}else if(($(".neck-parent .v-neck input[type='radio']:checked").length > 0) && ($(".neck-size-parent .v-neck-tab input[type='radio']:checked").length > 0)){

			let variant_price = $(".neck-size-parent .v-neck-tab input[type='radio']:checked").attr("variant-price");	
			let variant_compare = $(".neck-size-parent .v-neck-tab input[type='radio']:checked").attr("variant-compare");
			if (variant_compare == "undefined"){
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").removeClass("compare-price");

				$(".col-45 li label.price del, #sticky-product .addcart-price span.desktop-only del, .col-55 li label.price del, #sticky-product .title-color span.price del").remove();

				$(".col-45 li label.price span, #sticky-product .addcart-price span.desktop-only span, .col-55 li label.price span, #sticky-product .title-color span.price span").text(variant_price);
			}else{
				$(".col-45 li label.price, #sticky-product .addcart-price span.desktop-only, .col-55 li label.price, #sticky-product .title-color span.price").addClass("compare-price");
				
				$(".col-45 li label.price, .col-55 li label.price, #sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");

				//desktop
				$("#sticky-product .addcart-price span.desktop-only").html("<del>"+variant_compare+"</del><span class='single-price'>"+variant_price+"</span>");

				//mobile
				$("#sticky-product .title-color span.price").html("<del>"+variant_compare+"</del><span>"+variant_price+"</span>");
			}

			if ($(".swatch-element.soldout input[type='radio']:checked").length > 0){
				button_element.text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn");
				$("button.sticky-scroll").text("Out Of Stock").attr("disabled", "disabled").addClass("soldout-btn").show();
				$("button.sticky-cart").hide();
			}else{
				button_element.text("Add To Cart").removeAttr("disabled").removeClass("soldout-btn");
				$("button.sticky-scroll").text("Select Size").removeAttr("disabled").removeClass("soldout-btn").hide();
				$("button.sticky-cart").show();
			}
		}
	});
	/*neck,size tab radois button text change end*/

	// our-story team slider on mobile start
	$(".team-ul").slick({
	     slidesToShow: 1,
	     slidesToScroll: 1,
	     autoplay: false,
	     mobileFirst: true,
	     arrows: false,
	     dots: true,
	     infinite: true,
	     variableWidth: false,
	     centerMode: true,
	     cssEase: 'linear',
	     responsive: [
	        {
	           breakpoint: 767,
	           settings: "unslick"
	        }
	     ]
	});
	// our-story team slider on mobile end

	//contact page validation start
	$(".contact-form-submit").on("click", function(){
		var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
		var name = $.trim($("#ContactFormName").val());
		var email = $.trim($("#ContactFormEmail").val());
		//var subject = $.trim($("#ContactFormSubject").val());
		var subject = $.trim($("#ContactFormSubject").find("option:selected").attr('disabled'));
		var message = $.trim($("#ContactFormMessage").val());

        if(name.length == 0){
        	$(".error-name").text("Required").fadeIn();
        	$(".error-name").parent().css("color", "#cb4b4b");
        	$("#ContactFormName").css("border-color", "#cb4b4b");
        }else{
			$(".error-name").text("").fadeOut();
			$(".error-name").parent().css("color", "#242424");
			$("#ContactFormName").css("border-color", "#dbd9d4");
        }

        if(!pattern.test(email) || email.length == 0){
        	$(".error-email").text("Required").fadeIn();
        	$(".error-email").parent().css("color", "#cb4b4b");
        	$("#ContactFormEmail").css("border-color", "#cb4b4b");
        }
        else{
        	$(".error-email").text("").fadeOut();
        	$(".error-email").parent().css("color", "#242424");
        	$("#ContactFormEmail").css("border-color", "#dbd9d4");
        }

        if(subject){
        	$(".error-subject").text("Required").fadeIn();
        	$(".error-subject").parent().css("color", "#cb4b4b");
        	$("#ContactFormSubject").css("border-color", "#cb4b4b");
        }else{
			$(".error-subject").text("").fadeOut();
			$(".error-subject").parent().css("color", "#242424");
			$("#ContactFormSubject").css("border-color", "#dbd9d4");
        }

        if(message.length == 0 ){
        	$(".error-message").text("Required").fadeIn();
        	$(".error-message").parent().css("color", "#cb4b4b");
        	$("#ContactFormMessage").css("border-color", "#cb4b4b");
        }else{
			$(".error-message").text("").fadeOut();
			$(".error-message").parent().css("color", "#242424");
			$("#ContactFormMessage").css("border-color", "#dbd9d4");
        }

        if(name.length != 0 && pattern.test(email) && email.length != 0  && !subject && message.length !=0){
        	$(".contact-form-act-submit").click();
        }

	});
	//contact page validation end

	$(document).on('change','input[name="filter.p.m.custom.style"]',function(){
		const moreBtns = $('[data-more-btn]:checked');
		if(moreBtns.length && document.querySelector('.c-collectionsFilterStyle__button--moreButton') != null){
			document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.add('c-collectionsFilterStyle__button--isActiveMoreButton');
		} else{
		document.querySelector('.c-collectionsFilterStyle__button--moreButton').classList.remove('c-collectionsFilterStyle__button--isActiveMoreButton');
		}
	})

	  
   function ScrollExecute() {

     if($(document).height() - 1000 < ($(document).scrollTop() + $(window).height()) && $('#view-more').length && window.location.href.includes('/all')) {

         scrollNode = $('#view-more').last();    
         scrollURL = $('#view-more').last().attr("href");
         changeNode = $('#view-more').last();    
         pageNumber = $('#view-more').last().attr("href");
         pageUrl = pageNumber.split('page=')[0];
         pageNumber =  parseInt(pageNumber.split('page=')[1]);
         pagesEnd = $('.pagesEnd').text();
         pagesEnd = parseInt(pagesEnd);
       if(pagesEnd >= pageNumber){            
         if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
             $.ajax({
                 type: 'GET',
                 url: scrollURL,
                 beforeSend: function() {
                     scrollNode.hide();
                 },
                 success: function(data) {
                     var filteredData = $(data).find(".product-grid li");
                     filteredData.insertBefore( $("#product-list-foot") );
                      pageNumber ++;
                      changeNode.attr("href",pageUrl+"page="+pageNumber.toString());

                      changeNode.insertBefore( $("#product-list-foot") );
					  insertSwatches();
					  scrollNode.show();
                 },
                 dataType: "html"
             });
         }
       }
     }
   }

   $(document).ready(function () {
     $(window).scroll(function(){
       if(window.location.href.includes('/all')){
         ScrollExecute();
       }
       
     });
   });


	function handleSelect() {
	  $(".select-items label").on("click", function(){
		  var text = $(this).text();

		  $(".select-items div").each(function(){
			  if($(this).hasClass("same-as-selected")){
				  $(this).removeClass("same-as-selected");
			  }
		  });

		  $(this).addClass("same-as-selected");
		  $(this).parent().siblings(".select-selected").text(text);
		  $(this).parent().addClass("select-hide");
	  });

  }

	handleSelect()

function initSlick(id = '', options = {}) {
	$(id).slick(options)
}

window.initSlick = initSlick
